export enum IssueStatus {
  None = "NONE",
  Occur = "OCCUR",
  Solved = "SOLVED",
}
